import { jsx as _jsx } from "react/jsx-runtime";
import { Menu as AntdMenu } from 'antd';
import { useEffect, useState } from 'react';
import { getApiUrl } from '@/shared/utils';
import { ParseUrl2Svg } from './ParseUrl2Svg';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSharedGlobalState } from '@/shared/hooks';
import styles from './sider.module.less';
import { useMatchMenuItem } from '../hooks/useMatchMenuItem';
const setBusCategoryIdsSession = (busCategoryIds) => {
    sessionStorage.setItem('busCategoryIds', busCategoryIds || '');
};
const menuTitleStyle = {
    flex: 'auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};
const SvgCom = ({ icon, imgHeight = '22px' }) => {
    return _jsx(ParseUrl2Svg, { src: `${getApiUrl()}${icon?.startsWith('/') ? icon : `/${icon}`}`, className: "side-menu-icon", imgHeight: '40', imgWidth: imgHeight });
};
const packMenuData = (data, system, collapsed, isMenuUrlAddSystemName, count) => {
    return data?.map((resource) => {
        const { id, isExt = "", key, meta, openType, children = [], component: _url = '', externalUrl, parentId = '0', busCategoryIds } = resource;
        const { icon, title } = meta || {};
        const isFirstLevel = parentId === '0';
        const Icon = isFirstLevel ? (_jsx(SvgCom, { icon: icon })) : null;
        const isChildren = children && children?.length;
        const path = _url.startsWith('/') ? _url : '/' + _url;
        const url = isMenuUrlAddSystemName ? `/${system}${path}` : path;
        const titleStyle = { marginLeft: count * 12 };
        const systemPath = _url.split('/').length > 2 ? `${_url.split('/')[1]}` : '';
        const style = { ...menuTitleStyle, ...titleStyle, opacity: collapsed ? 0 : 1 };
        // isExt: 是否外部链接；openType【1：系统内访问，2：系统外部访问】
        const items = {
            label: isExt == "Y" && systemPath !== system && openType != 1 ? _jsx("a", { onClick: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (openType == 2) {
                        window.open(externalUrl ?? _url);
                    }
                    else {
                        window.location.href = externalUrl ?? _url;
                    }
                }, style: style, children: title })
                : !isChildren
                    ? _jsx(NavLink, { to: isExt == "Y" && openType == 1 && !externalUrl ? `/${id}` : url, state: isExt == "Y" && openType == 1 ? { component: externalUrl ?? _url, title } : undefined, style: style, onClick: () => {
                            setBusCategoryIdsSession(busCategoryIds);
                        }, children: title })
                    : _jsx("span", { style: style, children: title }),
            icon: Icon,
            key: id,
            children: isChildren
                ? packMenuData(children, system, collapsed, isMenuUrlAddSystemName, 1)
                : null,
        };
        return items;
    });
};
export const Menu = ({ collapsed }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { resourceList, system, _initStateByKey } = useSharedGlobalState();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [openKeys, setOpenKeys] = useState([]);
    const { isMenuUrlAddSystemName, systemName, iconPath } = useSharedGlobalState();
    const matchMenuItem = useMatchMenuItem();
    useEffect(() => {
        // if (pathname && pathname != '/' && matchMenuItem && matchMenuItem.children && matchMenuItem.children.length) {
        //   const firstChild = findFirstChild(matchMenuItem.children);
        //   if (firstChild && firstChild.key) {
        //     navigate(firstChild.key);
        //     return
        //   }
        // }
        if (matchMenuItem && matchMenuItem.busCategoryIds) {
            setBusCategoryIdsSession(matchMenuItem.busCategoryIds);
            _initStateByKey('busCategoryIds', matchMenuItem.busCategoryIds);
        }
        if (matchMenuItem && matchMenuItem.parentIds) {
            // 如果要展开多个目录,这么写
            // setOpenKeys((keys) => [...keys, ...matchMenuItem.parentIds]);
            setOpenKeys(() => [...matchMenuItem.parentIds]);
        }
        if (matchMenuItem && matchMenuItem.id) {
            setSelectedKeys([matchMenuItem.id]);
        }
    }, [matchMenuItem, _initStateByKey, pathname]);
    const otherItem = packMenuData(resourceList, system, collapsed, isMenuUrlAddSystemName, 0);
    return (_jsx(AntdMenu, { selectedKeys: selectedKeys, openKeys: openKeys, onOpenChange: (key) => {
            setOpenKeys(key);
        }, className: styles['shared-sider-menu'], style: { borderRight: 0 }, inlineIndent: 14, mode: "inline", theme: "light", inlineCollapsed: collapsed, items: [
            { key: 'system-name', icon: iconPath ? _jsx(ParseUrl2Svg, { src: iconPath, imgWidth: '22px', imgHeight: '22px' }) : null, label: _jsx("span", { className: styles['menu-system-name'], children: systemName }), title: systemName, },
            ...otherItem
        ] }));
};
